import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { IFaqBase } from '@/models/faqBase.model';

export enum SuggestedFaqEndpoints {
  ROOT = '/faq-suggestions',
}

export const staticSuggestedFaqEndpoints = {
  GET_SUGGESTED_FAQS: SuggestedFaqEndpoints.ROOT,
};

export const getSuggestedFaqEndpoints = ({ reviewId }: IGetSuggestedFaqByIdDTO) => ({
  GET_SUGGESTED_FAQ_BY_ID: `${SuggestedFaqEndpoints.ROOT}/${reviewId}`,
  APPROVE_SUGGESTED_FAQ: `${SuggestedFaqEndpoints.ROOT}/${reviewId}/approve`,
  REJECT_SUGGESTED_FAQ: `${SuggestedFaqEndpoints.ROOT}/${reviewId}/reject`,
});

export enum SuggestedFaqStatus {
  PENDING = 'pending',
  EDITED = 'edited',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface ISuggestedFaqSource {
  conversationId: string;
  messageId: string;
  channelId: number;
  occurredAt: string;
}

export interface ISuggestedFaqSourceChannel {
  channelId: number;
  slug: string;
  name: string;
}

export interface ISuggestedFaqBase {
  reviewId: string;
  question: string;
  answer: string | null;
  status: SuggestedFaqStatus;
  occurrenceCount: number;
  sourceChannels: ISuggestedFaqSourceChannel[];
}

export interface ISuggestedFaq extends ISuggestedFaqBase {
  rejectReason: string | null;
  reviewedBy: string | null;
  reviewedAt: string | null;
  resultingFaqId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface ISuggestedFaqDetails extends ISuggestedFaq {
  sources: ISuggestedFaqSource[];
  unresolvedSources: number;
  sourceSampleCap: number;
}

export interface IConversationSuggestion extends ISuggestedFaqBase {
  contributingConversations: number;
}

// ============== DTO ==============

export interface IGetSuggestedFaqByIdDTO {
  reviewId: string;
}

export interface IGetSuggestedFaqsDTO extends IPaginationDTO {
  question?: string;
  answer?: string;
  conversationId?: string;
  channelId?: number;
  status?: SuggestedFaqStatus;
  sort?: string;
}

export interface IApproveSuggestedFaqDTO {
  reviewId: string;
  question?: string;
  answer: string;
  isGeneral: boolean;
  channelIds?: number[];
}

export interface IRejectSuggestedFaqDTO {
  reviewId: string;
  reason: string;
}

export type TApproveSuggestedFaqInput = Omit<IApproveSuggestedFaqDTO, 'reviewId' | 'question'> & {
  question: string;
  originalQuestion: string;
};

export type TApproveSuggestedFaqTarget = Pick<IApproveSuggestedFaqDTO, 'isGeneral' | 'channelIds'>;

// ============== Response ==============

export interface IGetSuggestedFaqsResponse extends IPaginationResponse {
  suggestions: ISuggestedFaq[];
}

export interface IApproveSuggestedFaqResponse {
  suggestion: ISuggestedFaqDetails;
  faq: IFaqBase;
}
